/*
 * @Author: Tina Huang
 * @Date: 2024-02-20 09:49:22
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-11-01 14:06:22
 * @Description:
 */
import PickItem from './pick-items'
import { Card, List, Tag, Button, Tooltip } from 'antd'
import { Picks as picks, PickType } from '@/constants/picks'
import { useNavigate } from 'react-router-dom'
import useBind from '@/hooks/useBind'
// import { useEffect } from 'react'
// import Heart from '@/assets/svgs/heart'

export const PickListCard = () => {
  const navigate = useNavigate()
  const list = picks.filter((item) => !item.hide && !item.lock)
  const handleItemClick = (item: PickType) => {
    navigate(`/picks-detail/${item.id}`, { state: { id: item.id } })
  }

  return (
    <Card bordered={false}>
      <Card.Meta
        title={
          <div className="flex items-center">
            {/* <span className="mr-4">Notion模板库</span> */}
            <Button type="primary" ghost danger className="text-center font-bold" onClick={() => navigate('/vips')}>
              订阅Notion模板库
            </Button>
            <Button type="primary" ghost danger className="text-center font-bold ml-2" onClick={() => navigate('/picks-detail/54')}>
              订阅FlowUs模板库
            </Button>
          </div>
        }
      />
      <List
        className="demo-loadmore-list mt-2"
        itemLayout="horizontal"
        pagination={{ position: 'bottom', align: 'center', pageSize: 4, size: 'small' }}
        dataSource={list}
        renderItem={(item) => (
          <List.Item
            className="cursor-pointer"
            actions={[<>{item?.pay ? <Tag color="blue">{`¥${item?.pay}`}</Tag> : <Tag>免费</Tag>}</>]}
            onClick={() => handleItemClick(item)}
          >
            <List.Item.Meta
              title={
                <p className="w-full text-ellipsis text-nowrap overflow-hidden">
                  <Tag color={item?.flowus ? 'gold' : 'purple'}>{item?.flowus ? 'FlowUs' : 'Notion'}</Tag>
                  {item?.title}
                </p>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  )
}

export default function PickList(props: { lists: any; originList: any; __type: string | undefined; pickType: string }) {
  const navigate = useNavigate()
  const { lists, originList, __type } = props
  const isMobile = window.innerWidth <= 750
  const { show: showBind } = useBind()

  const Item = (props: { item: any; __type: any }) => {
    const { item, __type } = props
    return <PickItem item={item} key={item.id} from={__type} onShowBind={() => showBind()} />
  }

  const RecentTemps = () => {
    const _list = originList.filter((item: any) => !item.hide).slice(0, 5)
    const colors = ['magenta', 'gold', 'lime', 'geekblue', 'purple']
    const handleTagClick = (item: any) => {
      navigate(`/picks-detail/${item.id}`)
    }
    return (
      <div className="flex">
        {_list.map((item: any, index: number) => (
          <Tooltip
            title={<p dangerouslySetInnerHTML={{ __html: item?.description || item?.detail || item?.full_title || item?.title }}></p>}
          >
            <Tag color={colors[index]} className="py-1 px-2 mr-3 text-sm cursor-pointer" onClick={() => handleTagClick(item)}>
              {item.title}
            </Tag>
          </Tooltip>
        ))}
      </div>
    )
  }

  const ListContent = () => {
    const mobileList: any = [[], []]
    if (isMobile) {
      originList.map((item: any, index: number) => {
        mobileList[index % 2].push(item)
        return null
      })
    }
    return isMobile ? (
      <>
        {mobileList.map((list: any[], index: number) => (
          <div key={index} className={`w-1/2 flex flex-col ${index === 0 ? 'items-start' : 'items-end'}`}>
            {list.map((item) => (
              <Item item={item} __type={__type} />
            ))}
          </div>
        ))}
      </>
    ) : (
      <>
        {lists.map((list: any[], index: number) => (
          <div key={index}>
            {list.map((item) => (
              <Item item={item} __type={__type} />
            ))}
          </div>
        ))}
      </>
    )
  }

  const boxProps = isMobile ? 'w-full pt-5 flex justify-between' : 'pt-5 flex justify-between'

  return (
    <>
      {/* <div className="pt-4">
        <Radio.Group size="large">
          <Radio.Button value="pick">✏️ 模板</Radio.Button>
          <Radio.Button value="effes">⏸️ 视频</Radio.Button>
          <Radio.Button value="tools">📁 系列</Radio.Button>
        </Radio.Group>
      </div> */}
      {!isMobile && (
        <div className="pt-12 flex items-center flex-wrap">
          <span className="font-bold text-lg mr-2">最近更新 ➤ </span>
          <RecentTemps />
        </div>
      )}

      <div className={boxProps}>
        <ListContent />
      </div>
    </>
  )
}
